// extracted by mini-css-extract-plugin
export default {"container":"footer_container__QbKC-","wrapper":"footer_wrapper__3XTBO","description":"footer_description__RkyOP","logo":"footer_logo__ke--D","text":"footer_text__57Kjg"};